export const mockedTiles = [
  {
    code: 'appsurveyreport',
    title: 'Survey Report',
    description: 'Survey Report',
    tooltip: 'Survey Report',
    type: 'app',
    isEnabled: true,
  },
  {
    code: 'physurveyreport',
    title: 'Survey Report',
    description: 'Survey Report',
    tooltip: 'Survey Report',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'appaag',
    title: 'At-A-Glance',
    description: 'At A Glance',
    tooltip: 'At A Glance',
    type: 'app',
    isEnabled: true,
  },
  {
    code: 'phyaag',
    title: 'At-A-Glance',
    description: 'At A Glance',
    tooltip: 'At A Glance',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'appmanagedata',
    title: 'Manage Data',
    description: 'Manage Data',
    tooltip: 'Manage Data',
    type: 'app',
    isEnabled: true,
  },
  {
    code: 'phymanagedata',
    title: 'Manage Data',
    description: 'Manage Data',
    tooltip: 'Manage Data',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'appmarketpositioning',
    title: 'Market Positioning',
    description: 'Market Positioning',
    tooltip: 'Market Positioning',
    type: 'app',
    isEnabled: true,
  },
  {
    code: 'phymarketpositioning',
    title: 'Market Positioning',
    description: 'Market Positioning',
    tooltip: 'Market Positioning',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'appmarketmodeling',
    title: 'Market Modeling',
    description: 'Market Modeling',
    tooltip: 'Market Modeling',
    type: 'app',
    isEnabled: true,
  },
  {
    code: 'phymarketmodeling',
    title: 'Market Modeling',
    description: 'Market Modeling',
    tooltip: 'Market Modeling',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'appmarkettrends',
    title: 'Market Trends',
    description: 'Market Trends',
    tooltip: 'Market Trends',
    type: 'app',
    isEnabled: true,
  },
  {
    code: 'phymarkettrends',
    title: 'Market Trends',
    description: 'Market Trends',
    tooltip: 'Market Trends',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'phyoppassessmt',
    title: 'Opportunity Assessment',
    description: 'Opportunity Assessment',
    tooltip: 'Opportunity Assessment',
    type: 'phy',
    isEnabled: true,
  },
  {
    code: 'otheroncall',
    title: 'On Call',
    description: 'On Call',
    tooltip: 'On Call',
    type: 'other',
    isEnabled: true,
  },
]
